import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('../pages/dashboard/default')));
const NotFound = Loadable(lazy(() => import('../pages/component-overview/NotFoundPage')));

const Customer = Loadable(lazy(() => import('../pages/component-overview/Party/Customer/Customer')));
const PettyCash = Loadable(lazy(() => import('../pages/component-overview/PettyCash/PettyCash')));
const Invoice = Loadable(lazy(() => import('../pages/component-overview/Invoice/Invoice')));
const StockIn = Loadable(lazy(() => import('../pages/component-overview/Stock/Stock-In/StockIn')));
const StockOut = Loadable(lazy(() => import('../pages/component-overview/Stock/Stock-Out/StockOut')));
const DutiesTaxesRpt = Loadable(lazy(() => import('../pages/component-overview/Reports/Duties&TaxesRpt/DutiesTaxesRpt')));
const MonthlyInvoiceRpt = Loadable(lazy(() => import('../pages/component-overview/Reports/MonthlyInvoiceRpt/MonthlyInvoiceRpt')));
const MonthlyStatementRpt = Loadable(lazy(() => import('../pages/component-overview/Reports/MonthlyStatementRpt/MonthlyStatementRpt')));

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'customer',
      element: <Customer />
    },
    {
      path: 'petty-cash',
      element: <PettyCash />
    },
    {
      path: 'invoice',
      element: <Invoice />
    },
    {
      path: 'stock-in',
      element: <StockIn />
    },
    {
      path: 'stock-out',
      element: <StockOut />
    },
    {
      path: 'duties-taxes',
      element: <DutiesTaxesRpt />
    },
    {
      path: 'monthly-invoices',
      element: <MonthlyInvoiceRpt />
    },
    {
      path: 'monthly-statement',
      element: <MonthlyStatementRpt />
    },
    {
      path: '*',
      element: <NotFound />
    }
  ]
};

export default MainRoutes;
